import { Header              } from "../../main_components/header";
import { Loading             } from "../../main_components/loading.js";
import { VideoPlayerBody     } from "./video_player_body";
import { useState, useEffect } from "react";
export const VideoPlayer = ( props ) => {
    const { loadingDuration } = props;
    const [ isLoaded, setIsLoaded ] = useState(false);
    const [ toggle,   setToggle   ] = useState(true);
    useEffect(() => {
        window.onload = _=> setIsLoaded(true);
        setTimeout(_=> {
            setIsLoaded(true);
            setTimeout(_=>{ setToggle(false) }, 500);
            }, loadingDuration);
    }, []);
    return (
        <>
            { toggle && <Loading page={ "Video Player" } isLoaded={ isLoaded }/> }
            <Header link={ "Video_Player" }/>
            <VideoPlayerBody />
        </>
    );
};